export default [
  // { id: 1, name: 'communicationtype' },
  { id: 2, name: 'addresstype' },
  { id: 3, name: 'contactstatus' },
  { id: 4, name: 'documenttype' },
  { id: 5, name: 'documentstatus' },
  { id: 6, name: 'goodsgroup' },
  { id: 7, name: 'goodsstatus' },
  { id: 8, name: 'operationtype' },
  { id: 9, name: 'organizationstatus' },
  { id: 10, name: 'organizationtype' },
  { id: 11, name: 'plugcomstatus' },
  { id: 12, name: 'alertanalyzersettings' },
]
